import { render, staticRenderFns } from "./StandaloneEvents.vue?vue&type=template&id=43e27c64&scoped=true&"
import script from "./StandaloneEvents.vue?vue&type=script&lang=js&"
export * from "./StandaloneEvents.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneEvents.vue?vue&type=style&index=0&id=43e27c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e27c64",
  null
  
)

export default component.exports